/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunctionalLifestyleUpsertRequestDto
 */
export interface FunctionalLifestyleUpsertRequestDto {
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    energyLevels: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    mentalClarityFocus: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    moodEmotionalWellbeing: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    libidoSexualHealth: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    digestion: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    immuneFunction: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    fitnessLevel: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    skinAppearance: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    hairHealth: number;
    /**
     * 
     * @type {number}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    sleep: number;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    isOnboarding?: boolean;
    /**
     * Additional information about the functional lifestyle
     * @type {string}
     * @memberof FunctionalLifestyleUpsertRequestDto
     */
    additionalInformation?: string;
}

/**
 * Check if a given object implements the FunctionalLifestyleUpsertRequestDto interface.
 */
export function instanceOfFunctionalLifestyleUpsertRequestDto(value: object): value is FunctionalLifestyleUpsertRequestDto {
    if (!('energyLevels' in value) || value['energyLevels'] === undefined) return false;
    if (!('mentalClarityFocus' in value) || value['mentalClarityFocus'] === undefined) return false;
    if (!('moodEmotionalWellbeing' in value) || value['moodEmotionalWellbeing'] === undefined) return false;
    if (!('libidoSexualHealth' in value) || value['libidoSexualHealth'] === undefined) return false;
    if (!('digestion' in value) || value['digestion'] === undefined) return false;
    if (!('immuneFunction' in value) || value['immuneFunction'] === undefined) return false;
    if (!('fitnessLevel' in value) || value['fitnessLevel'] === undefined) return false;
    if (!('skinAppearance' in value) || value['skinAppearance'] === undefined) return false;
    if (!('hairHealth' in value) || value['hairHealth'] === undefined) return false;
    if (!('sleep' in value) || value['sleep'] === undefined) return false;
    return true;
}

export function FunctionalLifestyleUpsertRequestDtoFromJSON(json: any): FunctionalLifestyleUpsertRequestDto {
    return FunctionalLifestyleUpsertRequestDtoFromJSONTyped(json, false);
}

export function FunctionalLifestyleUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionalLifestyleUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'energyLevels': json['energyLevels'],
        'mentalClarityFocus': json['mentalClarityFocus'],
        'moodEmotionalWellbeing': json['moodEmotionalWellbeing'],
        'libidoSexualHealth': json['libidoSexualHealth'],
        'digestion': json['digestion'],
        'immuneFunction': json['immuneFunction'],
        'fitnessLevel': json['fitnessLevel'],
        'skinAppearance': json['skinAppearance'],
        'hairHealth': json['hairHealth'],
        'sleep': json['sleep'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
    };
}

export function FunctionalLifestyleUpsertRequestDtoToJSON(json: any): FunctionalLifestyleUpsertRequestDto {
    return FunctionalLifestyleUpsertRequestDtoToJSONTyped(json, false);
}

export function FunctionalLifestyleUpsertRequestDtoToJSONTyped(value?: FunctionalLifestyleUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'energyLevels': value['energyLevels'],
        'mentalClarityFocus': value['mentalClarityFocus'],
        'moodEmotionalWellbeing': value['moodEmotionalWellbeing'],
        'libidoSexualHealth': value['libidoSexualHealth'],
        'digestion': value['digestion'],
        'immuneFunction': value['immuneFunction'],
        'fitnessLevel': value['fitnessLevel'],
        'skinAppearance': value['skinAppearance'],
        'hairHealth': value['hairHealth'],
        'sleep': value['sleep'],
        'isOnboarding': value['isOnboarding'],
        'additionalInformation': value['additionalInformation'],
    };
}

